import BaseAPI from "../api";

const path: string = "/student";

export type listType = {
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
};

export class StudentApi extends BaseAPI {
  static getAllStudents(query?: listType): Promise<any> {
    return this.api.get(`${path}/list`, { params: { ...query } });
  }

  static getStudent(id: number): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }
  static getSingleStudent(
    id: number,
    type: string,
    id_student_term_payment: number
  ): Promise<any> {
    return this.api.get(
      `${path}/infomation/${id}/detail/${id_student_term_payment}?type=${type}`
    );
  }
  static updatedInformation(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/infomation/${id}/update`, body);
  }
  static deleteStudent(id_student: number): Promise<any> {
    return this.api.delete(`${path}/${id_student}/delete`);
  }

  static uploadDocument(
    studentId: number,
    file: FormData,
    name: string
  ): Promise<any> {
    return this.api.post(
      `${path}/infomation/${studentId}/upload/document?document_name=${name}`,
      file,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  }

  static downloadFileDocument(
    id_student: number,
    id_student_file: number
  ): Promise<any> {
    return this.api.get(
      `${path}/infomation/${id_student}/download/document?id_student_file=${id_student_file}`
    );
  }

  static deleteFileDocument(
    id_student: number,
    id_student_file: number
  ): Promise<any> {
    return this.api.delete(
      `${path}/infomation/${id_student}/delete/document?id_student_file=${id_student_file}`
    );
  }

  static resetPassword(
    id_student: number,
    body: {
      password: string;
    }
  ): Promise<any> {
    return this.api.patch(
      `${path}/${id_student}/password?password=${body.password}`
    );
  }

  static getEducation(id: number, query?: listType): Promise<any> {
    return this.api.get(`${path}/${id}/education`, {
      params: { ...query },
    });
  }
  static getEducationHead(
    id: number,
    id_student_educational?: number
  ): Promise<any> {
    return this.api.get(`${path}/${id}/education/${id_student_educational}`);
  }
  static getEducationDetail(
    id: number,
    id_student_educational?: number
  ): Promise<any> {
    return this.api.get(
      `${path}/${id}/education/${id_student_educational}/detail`
    );
  }
  static updateEducationDetail(
    id: number,
    id_student_educational?: number,
    body?: any
  ): Promise<any> {
    return this.api.patch(
      `${path}/${id}/education/${id_student_educational}/detail`,
      body
    );
  }
  static getCertificate(id: number): Promise<any> {
    return this.api.get(`${path}/${id}/certificate`);
  }

  static postCertificate(id: number, body?: any): Promise<any> {
    return this.api.post(`${path}/${id}/certificate`, body);
  }
  
  static postCertificateFile(id: number, body?: any): Promise<any> {
    return this.api.post(`${path}/${id}/certificate/file`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  static deleteCertificate(
    id: number,
    id_student_certificate?: any
  ): Promise<any> {
    return this.api.delete(
      `${path}/${id}/certificate/${id_student_certificate}`
    );
  }
  static deleteCertificateFile(
    id: number,
    id_student_certificate_file?: any
  ): Promise<any> {
    return this.api.delete(
      `${path}/${id}/certificate/file/${id_student_certificate_file}`
    );
  }
  static get_student_term_payment(id: number, query: any): Promise<any> {
    return this.api.get(`${path}/${id}/student_term_payment`, {
      params: { ...query },
    });
  }
  static get_student_term_payment_detail(id: number, id_student_term_payment: any): Promise<any> {
    return this.api.get(`${path}/${id}/student_term_payment/${id_student_term_payment}`);
  }
  static patchStatus(id: number, body?: any): Promise<any> {
    return this.api.patch(`${path}/${id}/status`, body);
  }
  static fetchGetPaymentInfo(
    id: number,
    id_register_payment: number,
    query?: listType
  ): Promise<any> {
    return this.api.get(`${path}/payment/${id}/${id_register_payment}/detail`, {
      params: { ...query },
    });
  }

  static fetchGetPaymentInfoDownload(
    id: number,
    id_register_payment: number,
    query?: listType
  ): Promise<any> {
    return this.api.get(
      `${path}/payment/${id}/${id_register_payment}/download`,
      {
        params: { ...query },
      }
    );
  }

  static fetchGetResigterInfo(
    id_register_payment: number,
    id: number,
    query?: listType
  ): Promise<any> {
    return this.api.get(
      `${path}/registration/${id}/${id_register_payment}/detail`,
      {
        params: { ...query },
      }
    );
  }

  static fetchUpdateResigterInfo(
    id: number,
    id_register_payment: number,
    body: any
  ): Promise<any> {
    return this.api.patch(
      `${path}/registration/${id}/${id_register_payment}/detail`,
      body
    );
  }

  static fetchGetEducationHistory(id: number, query?: listType): Promise<any> {
    return this.api.get(`${path}/history/${id}/list`, { params: { ...query } });
  }

  static fetchGetEducationHistoryDetail(
    id: number,
    id_education: number,
    query?: listType
  ): Promise<any> {
    return this.api.get(`${path}/history/${id}/${id_education}/detail`, {
      params: { ...query },
    });
  }

  static fetchGetCertificateDocument(
    id: number,
    query?: listType
  ): Promise<any> {
    return this.api.get(`${path}/certificate/${id}`, { params: { ...query } });
  }
  static fetchGetVisa(
    id: number,
    query?: listType
  ): Promise<any> {
    return this.api.get(`${path}/${id}/visa`, { params: { ...query } });
  }

  static fetchGetCertificateDocumentDownload(
    id_certificate: number,
    query?: listType
  ): Promise<any> {
    return this.api.get(`${path}/certificate/${id_certificate}/download`, {
      params: { ...query },
    });
  }

  static fetchGetVisaList(id: number, query?: listType): Promise<any> {
    return this.api.get(`${path}/visa/${id}`, { params: { ...query } });
  }

  static fetchGetTermFees(id: number, query?: listType): Promise<any> {
    return this.api.get(`${path}/term/fees/${id}`, {
      params: { ...query },
    });
  }

  static fetchGetTermFeesInfo(
    id_term_payment: number,
    query?: listType
  ): Promise<any> {
    return this.api.get(`${path}/term/fees/${id_term_payment}/detail`, {
      params: { ...query },
    });
  }
}
